import { render, staticRenderFns } from "./AfterSaleField.vue?vue&type=template&id=b8bbf500"
import script from "./AfterSaleField.vue?vue&type=script&lang=js"
export * from "./AfterSaleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports